import useSWR from 'swr'
import { API_BASE_URL } from 'config/api'
import { fetcher, IError } from 'utils/fetchers'

const apiUrl = `${API_BASE_URL}/cities`

interface City {
  id: number
  provinceId: number
  title: string
}

type Cities = City[]

export function useFetchCities() {
  const { data, error } = useSWR<Cities, IError | null>(`${apiUrl}`, fetcher)
  return {
    cities: data,
    isLoading: !error && !data,
    isError: !!error,
    error: error,
  }
}
